<script lang="ts">
  // Localization
  import { _, addMessages } from 'svelte-i18n'
  import en from './lang/en.json'

  import { init as init_locale, getLocaleFromNavigator } from 'svelte-i18n';
  import { setContext, getContext } from 'svelte';
  import { writable } from 'svelte/store';
  import { zonedTimeToUtc } from 'date-fns-tz';

  import SessionEditor from './SessionEditor.svelte';
  import SessionScheduler from './SessionScheduler.svelte';
  import SessionDetails from './SessionDetails.svelte';
  import SessionBrowser from './SessionBrowser.svelte';
  import XertTheme from './XertTheme.svelte';
  import SessionJoinButton from './SessionJoinButton.svelte';
  import SessionScheduleButton from './SessionScheduleButton.svelte';

  import GroupCommunityPickerModal from './GroupCommunityPickerModal.svelte';

  import { bootstrapConfirmation } from './Bootstrap';

  import { format_daymonth, format_time_of_day, time_update_minute } from './time';

  import FakeModal from './Bootstrap/FakeModal.svelte';

  import notify from './Bootstrap/Notification';
  import { preventDefault, unscheduleSession, playSessionNow, copyTemplate, isUserInSession, getRequest } from './Util/utils';
  import route from './Util/routes';
  import type { MyFitnessStores, Session, Template } from './MyFitness/stores';

  //export let sessions: any[] = [];

  export let myFitness: MyFitnessStores;
  let { userParams, sessions, sessionTemplates, notifications } = myFitness;

  type Xert = {
    Sessions: {
      urls,
      do_load_editor: boolean,
      do_load_scheduler: boolean,
      do_create_session: boolean,
      do_schedule_instance: boolean,
      session_id_to_open: string,
      session_obj: Session,
      session_template_id_to_open: string,
      session_template_obj: Template
    },
    Workouts,
  }
  export let xert: Xert;
  setContext('xert', xert);

  setContext('zoom_full_integration', xert.Sessions.zoom_full_integration);

  let session_editor: SessionEditor;
  let session_scheduler: SessionScheduler;

  let nav_stack: string[];
  let should_load_session_list: boolean;
  let should_load_editor = xert.Sessions.do_load_editor;
  let should_load_scheduler = xert.Sessions.do_load_scheduler;
  let do_schedule_instance = xert.Sessions.do_schedule_instance === true;

  // Indicates that this is a reduced-features version of the layout showing only upcoming sessions.
  let my_fitness_layout = xert.Sessions.my_fitness_layout ?? false;

  if (xert.Sessions.do_create_session === true) {
    should_load_session_list = false;
    nav_stack = ['wait'];
    setTimeout(()=>openNewTemplate());
  }
  /*else if (do_schedule_instace) {
    should_load_session_list = false;
    nav_stack = ["wait"];
    setTimeout(()=>openNewSession());
  }*/
  else if (xert.Sessions.session_id_to_open != null) {
    console.log('Load Scheduler!');
    should_load_session_list = false;
    nav_stack = ['wait'];
    let id = xert.Sessions.session_id_to_open;
    if (xert.Sessions.session_obj?.session_id == id) {
      setTimeout(()=> openSessionEditorWithSession(xert.Sessions.session_template_obj, xert.Sessions.session_obj), 0);
    } else {
      openSessionEditor(id)
    }
  }
  else if (xert.Sessions.session_template_id_to_open != null) {
    should_load_session_list = false;
    nav_stack = ['wait'];
    let id = xert.Sessions.session_template_id_to_open;
    //setTimeout(()=>openSessionEditor(id));
    if (xert.Sessions.session_template_obj?.template_id == id) {
      setTimeout(()=> openSessionEditorWithSession(xert.Sessions.session_template_obj, blankSession()), 0);
    } else {
      openSessionEditor(id)
    }
  }
  else {
    should_load_session_list = true;
    nav_stack = [''];
  }

  let logged_in: Boolean = xert.Sessions.logged_in;

  $: app_page = nav_stack[nav_stack.length-1];
  function replaceNav(page) {
    nav_stack.pop();
    nav_stack.push(page);
    nav_stack = nav_stack;

  }
  function pushNav(page) {
    nav_stack.push(page);
    nav_stack = nav_stack;
  }
  function navPopped(event){
    //nav_stack.pop();
    nav_stack = event.state ?? [''];
  }

  // Load locatization dictionaries synchronously.
  // (async load also available: https://github.com/kaisermann/svelte-i18n/blob/master/docs/Getting%20Started.md)
  init_locale({
    fallbackLocale: 'en',
    initialLocale: getLocaleFromNavigator(),
  })

  addMessages('en', en);
  addMessages('en-US', en);

  let all_workouts = [];

  let group_communities = writable([]);
  setContext('user_params', userParams);

  let loading_sessions = true;
  let error_loading_sessions = false;
  setContext('sessions', sessions);

  setContext('sessionTemplates', sessionTemplates);

  export function reloadSessions() {
    if (!logged_in) return Promise.reject();
    loading_sessions = true;
    error_loading_sessions = false;
    myFitness.postSessions([]);
    return window.fetch(xert.Sessions.urls.getSessions+'?'+(new Date()).getTime(), {
      ...getRequest(),
      method: 'get',
    })
    .then(response => response.json()).then(data=>{
      myFitness.postSessions(data);
      loading_sessions = false;
    }).catch(error => {
      loading_sessions = false;
      error_loading_sessions = true;
    });
  }

  let past_sessions_updated_at = [null, null, null];
  function loadMoreSessions(e) {
    if (!logged_in) return Promise.reject();
    loading_sessions = true;
    let url = route('SessionsController@getPastSessions');
    let updated_at = past_sessions_updated_at[e.detail.value];
    if (e.detail.value == 1) {
      url += '?from='+(Date.now()-7*24*3600*1000);
      if (updated_at != null) {
        url += '&updated='+updated_at;
      }
    } else if (e.detail.value == 2) {
      if (updated_at != null) {
        url += '?updated='+updated_at;
      }
    }
    return window.fetch(url, {
      ...getRequest(),
      method: 'get',
    })
    .then(response => response.json()).then(data=>{
      past_sessions_updated_at[e.detail.value] = e.detail.when.getTime();
      myFitness.updateSessions(data);
      loading_sessions = false;
    }).catch(error => {
      loading_sessions = false;
      // error_loading_sessions = true;
    });
  }
  // Not called here beause initial_sessions should be up to date.
  // reloadSessions();

  // Opens new scheduled session.
  function scheduleSession(template_id: string) {
    openTab(xert.Sessions.urls.new_instance.replace('PATH', template_id));
  }

  // Opens window with old scheduled session information.
  function rescheduleSession(session_id: string) {
    openTab(xert.Sessions.urls.getScheduler.replace('PATH', session_id));
  }

  // Set the session_to_schedule to the existing session that will be rescheduled.
  function openSessionSchedulerWithSession(sess: Session) {
    console.log('openSessionSchedulerWithSession running!');
    // Use spread operator to make a copy of the session object.
    session_to_schedule = {...sess};

    // Reset scroll to top.
    window.scroll(0,0);
    document.title = `Xert - ${session_to_schedule.name}`;
    //document.title = `Xert - Testing`;
    pushNav('schedule');
  }

  // Open the editor window.
  function editSession(path: string) {
    const url = route('SessionsController@getSessionEditor', [path]);
    window.location.href = url;
  }

  // Set the template_to_edit to existing template which will be edited.
  function openSessionEditorWithSession(template: Template, instance: Session = null) {
      // Use spread operator to make a copy of the session object.
      session_to_schedule = {...instance};
      // NOTE: The order of ...instance before ...template matters,
      // this way blankSession() has its null fields filled in by template
      template_to_edit = {...instance, ...template};
      //editor_button.click();

      // Reset scroll to top.
      window.scroll(0,0);
      document.title = `Xert - ${template_to_edit.name}`;
      pushNav('edit');
  }
  function openSessionEditor(template_id: string) {
    myFitness.getSessionTemplate(template_id).then(sess=> {
      openSessionEditorWithSession(sess);
    }).catch(error=> {
    })
  }
  
  // Clubs with permissions to schedule sessions.
  let clubs = writable([]);
  // All joined clubs.
  let all_clubs = writable([]);
  setContext('clubs', clubs);
  setContext('all_clubs', all_clubs);
  /*
  if (xert.Sessions.clubs != null) {
    clubs.set(xert.Sessions.clubs);
  }
  */

  if (logged_in) {
    console.log('Fetching clubs!');
    window.fetch(route('SessionsController@getCommunityListings'), {
      ...getRequest(),
      method: 'get',
    })
    .then(response => response.json())
    .then(data => {
      //sessions = data.sessions;
      clubs.set(data.filter(c=>c.allowed_to_edit));
      all_clubs.set(data);
    }).catch(error=>{
      console.log(error)
    });
  }

  function blankSession() { 
    // const now = zonedTimeToUtc(new Date()).toISOString();
    const now = (new Date()).toISOString();
    return {
      session_id: null,
      template_id: xert.Sessions.session_template_id_to_open,
      start_date: now,
      end_date: now,
      started: false,
      ended: false,
      repeat_type: 'none',
      sharing_type: 'public',
      allowed_users: null,
      members: null,
      is_group_session: false,
      invited_users: null,
      users_to_invite: null,
      users_to_schedule: null,
      community: null,
      is_zoom_media: false,
      zoom_autocreation: true,
      zoom_url: null,
      //owner: $user_params,
      owner: null,
    }
  };
  let session_to_schedule = blankSession();

  // Helper function for join button on session details page.
  // This updates the session_to_schedule variable with the joined state after joining/leaving.
  const joinSession = async (id, force)=>{
    const data = await myFitness.joinOrLeaveSession(session_to_schedule, force);
    if (session_to_schedule.session_id == data.session_id) {
        session_to_schedule = data;
    }
    return data
  }

  // Can be used with either scheduled sessions or session templates. A corresponding template/instance may have different owners.
  let is_owner = (session) => session.owner == null ? true : session.owner.username==xert._username;

  function blankTemplate() { 
    return {
      name: $_('sessions.editor.new_session'),
      template_id: null,
      //owner: $user_params,
      owner: null,
      owner_community: null,
      session_type: 'Personal',
      tags: null,
      venue: null,
      route_url: null,
      video_id: null,
      video_name: null,
      video_provider: null,
      video_offset: null,
      images: null,
      spotify_url: null,
      workout_id: null,
      workout_name: null,
      duration: 0,
      description: null,
      xss: 0,
      distance: 0,
      elevation: 0,
      focus: '',
      sfd: 0,
      difficulty: 0,
      rating: '',
      specificity: 0,
      specRating: '',
      spr: 0,
      allowedToEdit: true,
    }
  };
  let template_to_edit = blankTemplate();

  // allowedToEdit is a field in a session template db object.
  function allowedToEdit(template) {
    return logged_in && (template.allowedToEdit ?? false);
  }
  $: allowed_to_edit = allowedToEdit(template_to_edit);
  let show_session_editor = false;
  $: if(do_schedule_instance) {
    show_session_editor = should_load_editor;
  }
  else {
    show_session_editor = should_load_editor && allowed_to_edit;
  }

  // Scheduled session can be rescheduled by the owner, as long as it has not started.
  function allowedToReschedule(session) {
    return (session.owner != null && is_owner(session));
  }
  $: allowed_to_reschedule = allowedToReschedule(session_to_schedule);

  $: show_session_scheduler = should_load_scheduler;

  setContext('fetch-request', getRequest());


  function updateGroupCommunities() {
    if (logged_in) return window.fetch(route('UserController@getGroupCommunities'), {
      ...getRequest(),
      method: 'get',
    })
    .then(response => response.json())
    .then(data => {
      if (data.group_communities != null)
        group_communities.update((_)=>data.group_communities)
    }).catch(error=>{
      console.log(error)
    });
    else return Promise.reject();
  }
  updateGroupCommunities();

  function onWindowLoad(){
    window.addEventListener('popstate', navPopped)
    //window.addEventListener("hashchange", updateHref)
	}

  // Delete a session template.
  function deleteSession(template_id) {
    console.log('deleteSession called!');
    return window.fetch(`${xert.Sessions.urls.delete}/${template_id}`, {
      ...getRequest(),
      method: 'delete',
    })
    .then(response => response.json());
  }


  let editor_window;
  function openTab(url) {
    if (editor_window && !editor_window.closed) {
      editor_window.location = url;
      editor_window.focus();
    } else {
      editor_window = window.open(url, '_session');
    }
  }
  // Responsible for creating new sessions (templates).
  function createNewSession() {
    openTab(xert.Sessions.urls.new_session);
  }
  // Provides default values for a new session template.
  function openNewTemplate() {
    template_to_edit = blankTemplate();

    // Reset scroll to top.
    window.scroll(0,0);
    document.title = 'Xert - New Session';
    pushNav('edit');
  }
  // Provides default values for a new scheduled session.
  function openNewSession() {
    session_to_schedule = blankSession();

    // Reset scroll to top.
    window.scroll(0,0);
    document.title = 'Xert - New Scheduled Session';
    pushNav('schedule');
  }

  function onSessionSchedule(event) {
    //if (session_scheduler && !session_scheduler.checkValidity()) return Promise.reject();
    if (session_editor && !session_editor.checkValidity()) return Promise.reject();

    if (session_to_schedule.is_zoom_media && !session_to_schedule.zoom_autocreation && !isZoomLinkValid(session_to_schedule.zoom_url)) {
      // If the session uses a zoom link, check validity.
      notify({
        message: `Please provide a valid Zoom link in one of these formats: 
          <ul>
            <li>https://[zoom_server_address]/j/[meeting_id]</li>
            <li>https://[zoom_server_address]/j/[meeting_id]?pwd=[password]</li>
          </ul>`,
        level: 'danger',
        timeout: -1,
      });
      return Promise.reject();
    }
    return window.fetch(xert.Sessions.urls.createInstance, {
      ...getRequest(),
      method: 'post',
      body: JSON.stringify(template_to_edit),
    })
    .then(response => response.json())
    .then(data => {
      return data;
    });
  }

  function onSessionEdit(event) {
    if (session_editor && !session_editor.checkValidity()) return Promise.reject();

    return window.fetch(xert.Sessions.urls.createTemplate, {
      ...getRequest(),
      method: 'post',
      body: JSON.stringify(template_to_edit),
    })
    .then(response => response.json())
    .then(data => {
      return data;
    });
  }

  function isZoomLinkValid(zoom_link) {
    // Link contains zoom and has an extractable meeting id
    return zoom_link && zoom_link.includes('zoom') && /([0-9]{9,11})/.test(zoom_link);
  }

  // init notifications.
  $: notification_event = $notifications;

  function notifyEvent(event) {
    if (event != null) switch(event.type) {
      case 'session.delete':
      case 'session.update':
      notify(event);
        break;
      default:
        break;
    }
  }
  $: notifyEvent(notification_event);

  let session_just_joined = getContext('xert').Sessions?.joined_session;
  if (session_just_joined) {
    let error = getContext('xert').Sessions?.join_error;
    if (error) {
      console.log(error);
      if (error.type == 'overlap') {
        let message;
        if (error.n < 2) {
          message = 'You have an overlapping session scheduled. Leave that session and join this one?';
        } else {
          message = 'You have overlapping sessions scheduled. Leave these sessions and join this one?';
        }
        setTimeout(()=>{
          if(confirm(message)) {
            // Force join session, which clears conflicts.
            void myFitness.joinSessionById(session_just_joined, true);
          }
        }, 0);
      } else if (error.type == 'not-invited') {
        setTimeout(()=>
          notify({
            message: `Unfortunately, the session <b>${error.session.name}</b> is only available to members of <b>${error.community}</b>.`,
            //`Joined Session "${data.name};"`,
            //url: 'http://baronbiosys.com/how-to-join-a-session/',
            timeout: -1,
          }), 0);

      } else {
        setTimeout(()=>alert(error.msg));
      }

    } else void myFitness.getSession(session_just_joined).then((data)=>{
        if (data?.name != null && data?.club?.display_name != null) {
          let date_obj = new Date(data.start_date);
          let now = new Date();
          let date = format_daymonth(date_obj, now);
          let time = format_time_of_day(date_obj, now);
          notify({
            message: `Awesome!  You’ve joined ${data.club.display_name}’s <b>${data.name}</b> scheduled for <b>${date} at ${time}</b>!<br><br>Click the link below for help in getting everything you need ready for the session. <br><center><a target="_blank" href="/tutorial">Xert Sessions Tutorial</a></center>`,
            //`Joined Session "${data.name};"`,
            //url: 'http://baronbiosys.com/how-to-join-a-session/',
            timeout: -1,
          });
        }
    })
  }


  let showSessionInstances = ()=>{};
  // TODO: Move to MyFitnessStores
  function onGroupCommununitiesChange() {
    showSessionInstances();
    return Promise.allSettled([myFitness.updateUserParams(), reloadSessions()]);
  }
  $: group_communities_enabled = ($userParams?.features?.includes('sessionsGroupCommunities') ?? false) && $group_communities.length > 0;

</script>


<svelte:window on:load={onWindowLoad}/>

<root>
  <XertTheme/>

  {#if app_page == ''}
  <div style="{app_page == "" ? "" : "display: none;"}">
    <SessionBrowser on:loadsessions={loadMoreSessions} {reloadSessions} {error_loading_sessions} {loading_sessions} bind:showSessionInstances={showSessionInstances} hide_tabs={my_fitness_layout} hide_template_browser={my_fitness_layout} templates_promise={myFitness.getTemplatesPromise()} joinSession={myFitness.joinSessionById} {playSessionNow} {scheduleSession} {createNewSession} {allowedToEdit} {allowedToReschedule}>
      <li slot="tabs" class="tab-button" style="flex: 0 1 250px" on:auxclick={()=>{}}
        on:click={()=>{}}
        data-toggle="modal"
        data-target="#communityModal" >
        {#if group_communities_enabled}
        <a href="javascript:;" id="groupCommunityButton" class="nounderline">
          <i class="fa fa-users" data-placement="left"></i>
          {$_('sessions.browser.group_training_communities')}
        </a>
        {/if}
      </li>
    </SessionBrowser>
  </div>
  {#if group_communities_enabled}
      <GroupCommunityPickerModal group_communities={$group_communities} joinSession={myFitness.joinSessionById} onChange={onGroupCommununitiesChange}/>
  {/if}
  <!--TODO: nav state "schedule" is not used any more. should be able to delete this block-->
  {:else if app_page == 'schedule'}
    {#if session_to_schedule != null}
      <FakeModal id="schedulerModal">
        <buttons slot="title">
          {#if show_session_scheduler }
          <b style="flex-grow:1;">
            {#if xert.Sessions.session_obj == null}
            {$_('sessions.scheduler.schedule')}
            {:else}
            {$_('sessions.scheduler.reschedule')}
            {/if}
          </b>
          {:else if session_to_schedule.ended === false}
          <!--Do not show share button if session is ended...-->
            <a class="link" title={$_('sessions.card.share_session')} href="javascript:;"
                on:auxclick={preventDefault}
                on:click={()=>{
                  let session_join_url = `${xert.Sessions.urls.sessions_view}/${session_to_schedule.session_id}/details`;
                  // TODO: copy-pasta with SessionCard.svelte
                  navigator.clipboard.writeText(session_join_url).then(()=>
                    xert.info('Session URL copied to clipboard')
                  );
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 13.499V0.499023" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.5 4.99902L12 0.499023L16.5 4.99902" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15 8.5H19C19.2652 8.5 19.5196 8.60536 19.7071 8.79289C19.8946 8.98043 20 9.23478 20 9.5V22.5C20 22.7652 19.8946 23.0196 19.7071 23.2071C19.5196 23.3946 19.2652 23.5 19 23.5H5C4.73478 23.5 4.48043 23.3946 4.29289 23.2071C4.10536 23.0196 4 22.7652 4 22.5V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H9" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>
                {$_('sessions.editor.share')}
                </span>
            </a>
            <vr/>
          {/if}

          <!--TODO: delete instance button, reschedule button-->
          {#if session_to_schedule.session_id != null}
            {#if show_session_scheduler}
              <button use:bootstrapConfirmation={{
                onclick: (_)=>{
                    unscheduleSession(session_to_schedule.session_id)
                      .finally(()=>window.close());
                },
                title: $_('sessions.scheduler.unschedule')
              }} class="btn btn-default">
                <i class="fa-regular fa-trash-can" data-placement="left"></i>
                <span>
                {$_('sessions.scheduler.unschedule')}
                </span>
              </button>
            {:else}
              {#if allowed_to_reschedule}
                <button title={$_('sessions.scheduler.reschedule')} class="btn btn-default" on:click={()=>rescheduleSession(session_to_schedule.session_id)}>
                  <i class="fa fa-edit" data-placement="left"></i>
                  <span>
                  {$_('sessions.scheduler.reschedule')}
                  </span>
                </button>
              {/if}
            {/if}
          {/if}

          {#if show_session_scheduler}
            <button title={xert.Sessions.session_obj == null ? $_('sessions.scheduler.schedule') : $_('sessions.scheduler.reschedule')}
              class="btn btn-default" on:click={ (e)=>{
                onSessionSchedule(e)
                .then(()=>{
                  if (window.opener != null) {
                    // Close the curret tab if possible.
                    window.close();
                  } else {
                    // Otherwise refresh page.
                    window.location.reload();
                  }
                });
            }}>
                <i class="fa-regular fa-floppy-disk" data-placement="left"></i>
                <span>
                {#if xert.Sessions.session_obj == null}
                {$_('sessions.scheduler.schedule')}
                {:else}
                {$_('sessions.scheduler.reschedule')}
                {/if}
                </span>
            </button>
          {:else if logged_in}
            <SessionJoinButton
              {...session_to_schedule}
              {joinSession}
              joined={isUserInSession(session_to_schedule)}
              current_time={time_update_minute}
              current_time_highres={time_update_minute}
              show_leave_anchor={false}
              shorten_text={true}
              />
          {/if}
        </buttons>

        {#if session_to_schedule != null}
          {#key session_to_schedule.template_id}
            {#if show_session_scheduler}
              <!--
                TODO: Make this not as messy once spread binding is implemented.
                something like bind:{..session_to_edit}
                https://github.com/sveltejs/svelte/issues/5137
              -->
              <SessionScheduler
              bind:this={session_scheduler}
              bind:session_id={session_to_schedule.session_id}
              bind:template_id={session_to_schedule.template_id}
              bind:start_date={session_to_schedule.start_date}
              bind:end_date={session_to_schedule.end_date}
              bind:repeat_type={session_to_schedule.repeat_type}
              bind:sharing_type={session_to_schedule.sharing_type}
              bind:allowed_users={session_to_schedule.allowed_users}
              bind:members={session_to_schedule.members}
              bind:is_group_session={session_to_schedule.is_group_session}
              bind:invited_users={session_to_schedule.invited_users}
              bind:users_to_invite={session_to_schedule.users_to_invite}
              bind:users_to_schedule={session_to_schedule.users_to_schedule}
              bind:community={session_to_schedule.community}
              bind:is_zoom_media={session_to_schedule.is_zoom_media}
              bind:zoom_autocreation={session_to_schedule.zoom_autocreation}
              bind:zoom_url={session_to_schedule.zoom_url}
              bind:owner={session_to_schedule.owner}
              is_owner={is_owner(template_to_edit)}/>
            {:else}
            <!--
              <SessionDetails {...session_to_schedule}
                is_owner={is_owner(session_to_schedule)}
                current_time={time_update_minute}
                {logged_in}
              />
            -->
            {/if}
          {/key}
        {:else}
          <p>{$_('sessions.errors.no_session')}</p>
        {/if}
      </FakeModal>
    {:else}
      <p>{$_('sessions.errors.no_session')}</p>
    {/if}
  {:else if app_page == 'edit'}
    {#if template_to_edit != null}
      <FakeModal id="editorModal">
        <buttons slot="title">
          {#if show_session_editor }
          <b style="flex-grow:1;">
            {#if do_schedule_instance}
              {#if xert.Sessions.session_obj == null}
              {$_('sessions.scheduler.schedule')}
              {:else}
              {$_('sessions.editor.edit')}
              {/if}
            {:else}
              {#if template_to_edit.template_id != null}
              {$_('sessions.editor.edit')}
              {:else}
              {$_('sessions.editor.create_session')}
              {/if}
            {/if}
          </b>
          {/if}

          {#if template_to_edit.template_id != null}
            {#if show_session_editor}
              {#if do_schedule_instance}
                {#if session_to_schedule.session_id != null}
                <button use:bootstrapConfirmation={{
                    onclick: (_)=> unscheduleSession(session_to_schedule.session_id).finally(()=>window.close()),
                    title: $_('sessions.scheduler.unschedule')
                  }} class="btn btn-default">
                  <i class="fa-regular fa-trash-can" data-placement="left"></i>
                  <span>
                  {$_('sessions.scheduler.unschedule')}
                  </span>
                </button>
                {/if}
              {:else}
              <button use:bootstrapConfirmation={{
                onclick: (_)=>deleteSession(template_to_edit.template_id).finally(()=>window.close()),
                title: $_('sessions.editor.delete')
              }} class="btn btn-default">
                <i class="fa-regular fa-trash-can" data-placement="left"></i>
                <span>
                {$_('sessions.editor.delete')}
                </span>
              </button>
              {/if}
            {:else}
              {#if session_to_schedule.session_id}
                {#if session_to_schedule.ended === false}
                <!--Do not show share button if session is ended...-->
                  <a class="link" title={$_('sessions.card.share_session')} href="javascript:;"
                      on:auxclick={preventDefault}
                      on:click={()=>{
                        let session_join_url = `${xert.Sessions.urls.sessions_view}/${session_to_schedule.session_id}/details`;
                        // TODO: copy-pasta with SessionCard.svelte
                        navigator.clipboard.writeText(session_join_url).then(()=>
                          xert.info('Session URL copied to clipboard')
                        );
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 13.499V0.499023" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.5 4.99902L12 0.499023L16.5 4.99902" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 8.5H19C19.2652 8.5 19.5196 8.60536 19.7071 8.79289C19.8946 8.98043 20 9.23478 20 9.5V22.5C20 22.7652 19.8946 23.0196 19.7071 23.2071C19.5196 23.3946 19.2652 23.5 19 23.5H5C4.73478 23.5 4.48043 23.3946 4.29289 23.2071C4.10536 23.0196 4 22.7652 4 22.5V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H9" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span>
                      {$_('sessions.editor.share')}
                      </span>
                  </a>
                  <vr/>
                {/if}
                {#if allowed_to_reschedule}
                  <button title={$_('sessions.scheduler.reschedule')} class="btn btn-default" on:click={()=>rescheduleSession(session_to_schedule.session_id)}>
                    <i class="fa fa-edit" data-placement="left"></i>
                    <span>
                    {$_('sessions.editor.edit')}
                    </span>
                  </button>
                {/if}
              {:else if allowed_to_edit}
                <button title={$_('sessions.editor.edit')} class="btn btn-default" on:click={()=>editSession(template_to_edit.template_id)}>
                  <i class="fa fa-edit" data-placement="left"></i>
                  <span>
                  {$_('sessions.editor.edit')}
                  </span>
                </button>
              {/if}
            {/if}

            {#if logged_in && session_to_schedule.session_id == null && !do_schedule_instance}
            <button title={$_('sessions.editor.copy')} class="btn btn-default" on:click={()=>copyTemplate(template_to_edit).then(()=>{window.close()})}>
              <i class="fa-regular fa-copy" data-placement="left"></i>
              <span>
              {$_('sessions.editor.copy')}
            </span>
            </button>
            {/if}
          {/if}
          {#if show_session_editor}
            {#if do_schedule_instance}
            <button title={xert.Sessions.session_obj == null ? $_('sessions.scheduler.schedule') : $_('sessions.scheduler.reschedule')}
              class="btn btn-default" on:click={ (e)=>{
                onSessionSchedule(e)
                .then((data)=>session_editor?.uploadImages(data))
                .then(()=>{
                  if (window.opener != null) {
                    // Close the curret tab if possible.
                    window.close();
                  } else {
                    // Otherwise refresh page.
                    window.location.reload();
                  }
                })
                .catch((e)=>{
                  console.log('onSessionSchedule rejected!');
                  console.log(e);
                })
                ;
            }}>
                <i class="fa-regular fa-floppy-disk" data-placement="left"></i>
                <span>
                {#if xert.Sessions.session_obj == null}
                {$_('sessions.scheduler.schedule')}
                {:else}
                {$_('sessions.scheduler.reschedule')}
                {/if}
                </span>
            </button>
            {:else}
            <button title={template_to_edit.template_id != null ? $_('sessions.editor.update') : $_('sessions.editor.create')}
              class="btn btn-default" on:click={ (e)=>{
                onSessionEdit(e)
                .then((data)=>session_editor?.uploadImages(data))
                .then(()=>{
                  if (window.opener != null) {
                    // Close the curret tab if possible.
                    window.close();
                  } else {
                    // Otherwise refresh page.
                    window.location.reload();
                  }
                });
            }}>
                <i class="fa-regular fa-floppy-disk" data-placement="left"></i>
                <span>
                {#if template_to_edit.template_id != null}
                {$_('sessions.editor.update')}
                {:else}
                {$_('sessions.editor.create')}
                {/if}
                </span>
            </button>
            {/if}
          {:else if logged_in}
            {#if session_to_schedule.session_id != null }
            <SessionJoinButton
              {...session_to_schedule}
              {joinSession}
              joined={isUserInSession(session_to_schedule)}
              current_time={time_update_minute}
              current_time_highres={time_update_minute}
              show_leave_anchor={false}
              shorten_text={true}
              />
            {:else if template_to_edit.template_id != null}
            <SessionScheduleButton 
              disabled={!template_to_edit.allowed_to_schedule}
              flexDirection="row"
              scheduleThisSession={()=>{
                return scheduleSession(template_to_edit.template_id);
              }}
              playSessionNow={()=>{
                return playSessionNow(template_to_edit);
              }}
              {...template_to_edit}
              start_date={null}
              details_page={true}
              is_premium={$userParams.premium}
              />
            {/if}
          {/if}
        </buttons>

        {#if template_to_edit != null}
          {#key template_to_edit.template_id}
            {#if show_session_editor}
              <!--
                TODO: Make this not as messy once spread binding is implemented.
                something like bind:{..session_to_edit}
                https://github.com/sveltejs/svelte/issues/5137
              -->
              <SessionEditor
                bind:this={session_editor}
                bind:template_id={template_to_edit.template_id}

                bind:session_id={template_to_edit.session_id}
                bind:start_date={template_to_edit.start_date}
                bind:repeat_type={template_to_edit.repeat_type}
                bind:sharing_type={template_to_edit.sharing_type}
                bind:allowed_users={template_to_edit.allowed_users}
                bind:members={template_to_edit.members}
                bind:is_group_session={template_to_edit.is_group_session}
                bind:is_zoom_media={template_to_edit.is_zoom_media}
                bind:zoom_autocreation={template_to_edit.zoom_autocreation}
                bind:invited_users={template_to_edit.invited_users}
                bind:users_to_invite={template_to_edit.users_to_invite}
                bind:users_to_schedule={template_to_edit.users_to_schedule}
                bind:community={template_to_edit.community}

                bind:session_type={template_to_edit.session_type}
                bind:owner={template_to_edit.owner}
                bind:owner_community={template_to_edit.owner_community}
                bind:tags={template_to_edit.tags}
                bind:venue={template_to_edit.venue}
                bind:route_url={template_to_edit.route_url}
                bind:video_id={template_to_edit.video_id}
                bind:video_name={template_to_edit.video_name}
                bind:video_provider={template_to_edit.video_provider}
                bind:video_offset={template_to_edit.video_offset}
                bind:images={template_to_edit.images}
                bind:spotify_url={template_to_edit.spotify_url}
                bind:workout_id={template_to_edit.workout_id}
                bind:workout_name={template_to_edit.workout_name}
                bind:duration={template_to_edit.duration}
                bind:name={template_to_edit.name}
                bind:description={template_to_edit.description}
                bind:xss={template_to_edit.xss}
                bind:distance={template_to_edit.distance}
                bind:elevation={template_to_edit.elevation}
                bind:focus={template_to_edit.focus}
                bind:sfd={template_to_edit.sfd}
                bind:difficulty={template_to_edit.difficulty}
                bind:rating={template_to_edit.rating}
                bind:specificity={template_to_edit.specificity}
                bind:specRating={template_to_edit.specRating}
                bind:spr={template_to_edit.spr}
                is_owner={is_owner(template_to_edit)}
                {do_schedule_instance}
              />
            {:else}
              <SessionDetails {...template_to_edit}
                is_owner={is_owner(template_to_edit)}
                current_time={time_update_minute}
                {logged_in}
              />
            {/if}
          {/key}
        {:else}
          <p>{$_('sessions.errors.no_session')}</p>
        {/if}
      </FakeModal>
    {:else}
      <p>{$_('sessions.errors.no_session')}</p>
    {/if}
  {:else}
    <!-- Loading spinner... -->
    <flex-container style="justify-content: center; padding-top: 48px;">
      <div style="color: var(--color-xert-teal); font-size: 32px; flex: 0 0 0;" class="fas fa-circle-notch fa-spin"/>
    </flex-container>
  {/if}

</root>

<style lang="scss">
  @import './style/xert.scss';
  buttons {
    display: flex;
    justify-content: flex-end;
    gap: 20px;

    --xert-button-width: 210px;

    > .btn-default {
      margin: 10px 0;
    }

    @media(max-width: $media-size-sm) {
      --xert-button-display-text: none;
      --xert-button-width: 135px;
      > button, > a {
        > span {
          display: none;
        }
      }
    }
  }
  .link {
    /* Link */

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    display: flex;
    align-items: center;
    letter-spacing: 0.129369px;

    color: #8B8B8B;
    > svg {
      margin-right: 10px;
    }
  }

  .page-title {
    display: flex;
  }
</style>
